import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=49d294cc"
import script from "./base-layout.ts?vue&type=script&lang=ts&external"
export * from "./base-layout.ts?vue&type=script&lang=ts&external"
import style0 from "./base-layout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports